<template>
  <v-row>
    <v-col cols="12">
      <create-environment />
    </v-col>
  </v-row>
</template>

<script>
import CreateEnvironment from '@/components/Services/Hosting/Shared/Wordpress/Staging/CreateEnvironment'

export default {
  name: 'StagingView',
  components: {
    CreateEnvironment
  },
  data: () => ({

  }),
}
</script>

<style scoped>

</style>
